<!-- Modal de Gerenciamento de Perguntas Customizadas -->
<div *ngIf="isOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col mx-4">
        <!-- Header -->
        <div class="flex justify-between items-center p-6 border-b">
            <h1 class="font-bold text-2xl">Gerenciar Perguntas da Anamnese</h1>
            <div (click)="close()" class="cursor-pointer hover:text-neutral-900">
                <fa-icon [icon]="faTimes" size="lg"></fa-icon>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="flex justify-center items-center py-20">
            <app-loading></app-loading>
        </div>

        <!-- Conteúdo Principal -->
        <div *ngIf="!loading" class="flex-1 overflow-y-auto p-6">
            <!-- Seções -->
            <div *ngFor="let section of sections; let sectionIndex = index" class="mb-8">
                <!-- Header da Seção -->
                <div class="bg-gray-100 rounded-lg p-4 mb-4">
                    <div class="flex justify-between items-center cursor-pointer" (click)="toggleSection(sectionIndex)">
                        <div>
                            <h3 class="font-semibold text-lg">{{ section.name }}</h3>
                            <p class="text-sm text-gray-600">{{ section.questions.length }} perguntas customizadas</p>
                        </div>
                        <div class="text-gray-500">
                            <span *ngIf="section.expanded">↑</span>
                            <span *ngIf="!section.expanded">↓</span>
                        </div>
                    </div>
                </div>

                <!-- Perguntas da Seção -->
                <div *ngIf="section.expanded" class="space-y-4">
                    <!-- Lista de Perguntas -->
                    <div *ngFor="let question of section.questions; let questionIndex = index" 
                         class="border border-gray-200 rounded-lg p-4 bg-white">
                        
                        <!-- Modo Visualização -->
                        <div *ngIf="!question.isEditing" class="space-y-3">
                            <div class="flex justify-between items-start">
                                <div class="flex-1">
                                    <div class="flex items-center gap-2 mb-2">
                                        <span class="font-medium">{{ question.label }}</span>
                                        <span *ngIf="question.is_required" class="text-red-500 text-sm">(Obrigatória)</span>
                                    </div>
                                    <div class="text-sm text-gray-600 mb-2">
                                        <span class="bg-blue-100 text-blue-800 px-2 py-1 rounded">
                                            {{ getQuestionTypeLabel(question.type) }}
                                        </span>
                                        <span class="ml-2">Ordem: {{ question.order_in_section }}</span>
                                    </div>
                                    <div *ngIf="question.help_text" class="text-sm text-gray-500 italic">
                                        {{ question.help_text }}
                                    </div>
                                </div>
                                
                                <!-- Controles de Pergunta -->
                                <div class="flex items-center gap-2 ml-4">
                                    <!-- Mover para cima -->
                                    <button *ngIf="questionIndex > 0" 
                                            (click)="moveQuestionUp(sectionIndex, questionIndex)"
                                            class="p-1 hover:bg-gray-100 rounded text-gray-500">
                                        ↑
                                    </button>
                                    
                                    <!-- Mover para baixo -->
                                    <button *ngIf="questionIndex < section.questions.length - 1" 
                                            (click)="moveQuestionDown(sectionIndex, questionIndex)"
                                            class="p-1 hover:bg-gray-100 rounded text-gray-500">
                                        ↓
                                    </button>
                                    
                                    <!-- Editar -->
                                    <button (click)="editQuestion(sectionIndex, questionIndex)"
                                            class="p-1 hover:bg-blue-100 rounded text-blue-600">
                                        <fa-icon [icon]="faEdit"></fa-icon>
                                    </button>
                                    
                                    <!-- Excluir -->
                                    <button (click)="confirmDeleteQuestion(sectionIndex, questionIndex)"
                                            class="p-1 hover:bg-red-100 rounded text-red-600">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </div>
                            </div>

                            <!-- Opções da Pergunta (se aplicável) -->
                            <div *ngIf="question.options && question.options.length > 0" class="ml-4 space-y-2">
                                <div class="text-sm font-medium text-gray-700">Opções:</div>
                                <div *ngFor="let option of question.options" class="flex items-center gap-2 text-sm">
                                    <span class="w-2 h-2 bg-gray-400 rounded-full"></span>
                                    <span>{{ option.label }}</span>
                                    <span *ngIf="option.triggersFreeText" class="text-blue-600 text-xs">(abre campo de texto)</span>
                                </div>
                            </div>
                        </div>

                        <!-- Modo Edição -->
                        <div *ngIf="question.isEditing" class="space-y-4">
                            <!-- Campos básicos da pergunta -->
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Texto da pergunta *</label>
                                    <input type="text" 
                                           [(ngModel)]="question.label"
                                           class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                           placeholder="Digite o texto da pergunta">
                                </div>
                                
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Tipo de pergunta *</label>
                                    <select [(ngModel)]="question.type" 
                                            (ngModelChange)="onQuestionTypeChange(sectionIndex, questionIndex)"
                                            class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                                        <option *ngFor="let type of questionTypes" [value]="type.value">
                                            {{ type.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Texto de ajuda</label>
                                    <input type="text" 
                                           [(ngModel)]="question.help_text"
                                           class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                           placeholder="Texto de ajuda (opcional)">
                                </div>
                                
                                <div class="flex items-center">
                                    <input type="checkbox" 
                                           [(ngModel)]="question.is_required"
                                           [id]="'required_' + sectionIndex + '_' + questionIndex"
                                           class="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                                    <label [for]="'required_' + sectionIndex + '_' + questionIndex" 
                                           class="text-sm font-medium text-gray-700">
                                        Pergunta obrigatória
                                    </label>
                                </div>
                            </div>

                            <!-- Gerenciamento de Opções (para SINGLE_CHOICE e MULTIPLE_CHOICE) -->
                            <div *ngIf="question.type === 'SINGLE_CHOICE' || question.type === 'MULTIPLE_CHOICE'" 
                                 class="border-t pt-4">
                                <div class="flex justify-between items-center mb-3">
                                    <h4 class="font-medium">Opções de resposta</h4>
                                    <button (click)="addOption(sectionIndex, questionIndex)"
                                            class="border border-neutral-800 cursor-pointer font-medium rounded-md px-3 py-2 mr-2">
                                        <fa-icon [icon]="faPlus" size="xs"></fa-icon>
                                        Adicionar opção
                                    </button>
                                </div>

                                <!-- Lista de Opções -->
                                <div *ngFor="let option of question.options; let optionIndex = index" 
                                     class="flex items-center gap-2 mb-2 p-2 bg-gray-50 rounded">
                                    
                                    <!-- Modo visualização da opção -->
                                    <div *ngIf="!option.isEditing" class="flex-1 flex items-center gap-2">
                                        <span class="w-6 text-center text-sm text-gray-500">{{ option.order }}</span>
                                        <span class="flex-1">{{ option.label }}</span>
                                        <span *ngIf="option.triggersFreeText" class="text-blue-600 text-xs">(abre campo de texto)</span>
                                        
                                        <!-- Controles da opção -->
                                        <div class="flex items-center gap-1">
                                            <button *ngIf="optionIndex > 0" 
                                                    (click)="moveOptionUp(sectionIndex, questionIndex, optionIndex)"
                                                    class="p-1 hover:bg-gray-200 rounded text-xs">
                                                ↑
                                            </button>
                                            <button *ngIf="optionIndex < question.options!.length - 1" 
                                                    (click)="moveOptionDown(sectionIndex, questionIndex, optionIndex)"
                                                    class="p-1 hover:bg-gray-200 rounded text-xs">
                                                ↓
                                            </button>
                                            <button (click)="option.isEditing = true"
                                                    class="p-1 hover:bg-blue-200 rounded text-blue-600">
                                                <fa-icon [icon]="faEdit" size="xs"></fa-icon>
                                            </button>
                                            <button (click)="deleteOption(sectionIndex, questionIndex, optionIndex)"
                                                    class="p-1 hover:bg-red-200 rounded text-red-600">
                                                <fa-icon [icon]="faTrash" size="xs"></fa-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Modo edição da opção -->
                                    <div *ngIf="option.isEditing" class="flex-1 flex items-center gap-2">
                                        <span class="w-6 text-center text-sm text-gray-500">{{ option.order }}</span>
                                        <input type="text" 
                                               [(ngModel)]="option.label"
                                               (ngModelChange)="onOptionLabelChange(sectionIndex, questionIndex, optionIndex, $event)"
                                               class="flex-1 p-1 border border-gray-300 rounded text-sm"
                                               placeholder="Texto da opção">
                                        <div class="flex items-center text-xs">
                                            <input type="checkbox" 
                                                   [(ngModel)]="option.triggersFreeText"
                                                   class="mr-1">
                                            <span>abre campo de texto</span>
                                        </div>
                                        
                                        <!-- Botões de ação da opção -->
                                        <button (click)="saveOption(sectionIndex, questionIndex, optionIndex)"
                                                class="p-1 hover:bg-green-200 rounded text-green-600">
                                            <fa-icon [icon]="faCheck" size="xs"></fa-icon>
                                        </button>
                                        <button (click)="cancelEditOption(sectionIndex, questionIndex, optionIndex)"
                                                class="p-1 hover:bg-gray-200 rounded text-gray-600">
                                            <fa-icon [icon]="faTimes" size="xs"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Botões de ação da pergunta -->
                            <div class="flex justify-end gap-2 pt-3 border-t">
                                <button (click)="cancelEditQuestion(sectionIndex, questionIndex)"
                                        class="px-3 py-1 border border-gray-300 rounded text-sm hover:bg-gray-50">
                                    Cancelar
                                </button>
                                <button (click)="saveQuestion(sectionIndex, questionIndex)"
                                        class="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm">
                                    Salvar Pergunta
                                    <span *ngIf="hasOptionsInEditing(question)" 
                                          class="text-xs opacity-75 ml-1">(+ opções)</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Botão Adicionar Pergunta -->
                    <div class="flex justify-center">
                        <button (click)="addQuestion(sectionIndex)"
                                class="flex items-center gap-2 bg-westetics-blue hover:bg-westetics-blue-dark text-white px-4 py-2 rounded-md">
                            <fa-icon [icon]="faPlus"></fa-icon>
                            Adicionar Pergunta
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div *ngIf="!loading" class="flex justify-between items-center p-6 border-t bg-gray-50">
            <div class="text-sm text-gray-600">
                <span *ngIf="hasUnsavedChanges()" class="text-orange-600">
                    <fa-icon [icon]="faExclamationTriangle" class="mr-1"></fa-icon>
                    Há alterações não salvas
                </span>
            </div>
            <div class="flex gap-3">
                <button (click)="showClearAllModal()"
                        class="px-4 py-2 border border-red-300 text-red-700 rounded-md hover:bg-red-50">
                    Limpar perguntas
                </button>
                <button (click)="showCopyFromClinicModal()"
                        class="px-4 py-2 border border-blue-300 text-blue-700 rounded-md hover:bg-blue-50 flex items-center gap-2">
                    <fa-icon [icon]="faCopy"></fa-icon>
                    Copiar de outra Clínica
                </button>
                <button (click)="close()"
                        class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                    Cancelar
                </button>
                <button (click)="showPublishModal()"
                        [disabled]="publishLoading"
                        class="px-4 py-2 bg-westetics-blue hover:bg-westetics-blue-dark text-white rounded-md disabled:bg-gray-400">
                    <span *ngIf="!publishLoading">Publicar</span>
                    <span *ngIf="publishLoading">Publicando...</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal de Confirmação de Limpeza -->
<div *ngIf="showClearConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faExclamationTriangle" class="text-red-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg">Confirmar Limpeza</h3>
        </div>
        <p class="text-gray-600 mb-6">
            Tem certeza que deseja excluir todas as perguntas?
            Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="cancelClearAll()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Cancelar
            </button>
            <button (click)="confirmClearAll()"
                    class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md">
                Limpar
            </button>
        </div>
    </div>
    
</div>

<!-- Modal de Seleção de Clínica -->
<div *ngIf="showClinicSelectionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-3xl w-full mx-4 max-h-[80vh] overflow-hidden flex flex-col">
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="font-bold text-lg">Copiar de Outra Clínica</h3>
                <p class="text-sm text-gray-600">Selecione a clínica de origem para copiar suas perguntas personalizadas.</p>
            </div>
            <button type="button" (click)="cancelClinicSelection()" class="text-gray-500 hover:text-gray-800">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>

        <div class="mb-4">
            <label for="clinicSearch" class="block text-sm font-medium text-gray-700 mb-1">Buscar clínica</label>
            <input id="clinicSearch" type="text" [(ngModel)]="clinicSearchTerm" (ngModelChange)="filterCompanies($event)"
                   class="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-westetics-blue focus:border-westetics-blue"
                   placeholder="Digite o nome ou CNPJ da clínica" />
        </div>

        <div class="border border-gray-200 rounded-lg flex-1 overflow-hidden">
            <div *ngIf="loadingCompanies" class="w-full h-full flex items-center justify-center py-10">
                <app-loading></app-loading>
            </div>
            <div *ngIf="!loadingCompanies" class="max-h-80 overflow-y-auto divide-y">
                <div *ngIf="filteredCompanies.length === 0" class="p-6 text-center text-sm text-gray-500">
                    Nenhuma clínica encontrada.
                </div>
                <button type="button" *ngFor="let company of filteredCompanies"
                        (click)="selectSourceClinic(company)"
                        class="w-full text-left px-4 py-3 flex items-center justify-between hover:bg-gray-50"
                        [ngClass]="{ 'bg-blue-50 border-l-4 border-westetics-blue': selectedSourceClinic?.cnpj === company.cnpj }">
                    <div>
                        <p class="font-medium flex items-center gap-2">
                            <fa-icon [icon]="faBuilding" class="text-gray-400"></fa-icon>
                            {{ company.corporate_name || 'Clínica sem nome' }}
                        </p>
                        <p class="text-sm text-gray-600">CNPJ: {{ company.cnpj }}</p>
                    </div>
                    <fa-icon *ngIf="selectedSourceClinic?.cnpj === company.cnpj" [icon]="faCheck" class="text-westetics-blue"></fa-icon>
                </button>
            </div>
        </div>

        <div class="flex justify-end gap-3 mt-6">
            <button (click)="cancelClinicSelection()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Cancelar
            </button>
            <button (click)="openCopyConfirmationModal()"
                    [disabled]="!selectedSourceClinic"
                    class="px-4 py-2 bg-westetics-blue hover:bg-westetics-blue-dark text-white rounded-md disabled:bg-gray-400 disabled:cursor-not-allowed">
                Copiar
            </button>
        </div>
    </div>
</div>

<!-- Modal de Confirmação de Cópia -->
<div *ngIf="showCopyConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faExclamationTriangle" class="text-orange-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg">Confirmar Cópia</h3>
        </div>
        <p class="text-gray-600 mb-4">
            As perguntas personalizadas da clínica de origem irão substituir as perguntas atuais desta clínica.
            Deseja continuar?
        </p>
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6 space-y-4">
            <div>
                <p class="text-xs uppercase text-gray-500">Origem</p>
                <p class="font-semibold">{{ selectedSourceClinic?.corporate_name || 'Clínica selecionada' }}</p>
                <p class="text-sm text-gray-600">CNPJ: {{ selectedSourceClinic?.cnpj }}</p>
            </div>
            <div>
                <p class="text-xs uppercase text-gray-500">Destino</p>
                <p class="font-semibold">Clínica atual</p>
                <p class="text-sm text-gray-600">CNPJ: {{ companyCnpj }}</p>
            </div>
        </div>
        <div class="flex justify-end gap-3">
            <button (click)="cancelCopy()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Voltar
            </button>
            <button (click)="confirmCopyFromClinic()"
                    [disabled]="copyLoading"
                    class="px-4 py-2 bg-westetics-blue hover:bg-westetics-blue-dark text-white rounded-md disabled:bg-gray-400">
                <span *ngIf="!copyLoading">Confirmar cópia</span>
                <span *ngIf="copyLoading">Copiando...</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal de Confirmação de Publicação -->
<div *ngIf="showPublishConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faExclamationTriangle" class="text-orange-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg">Confirmar Publicação</h3>
        </div>
        <p class="text-gray-600 mb-6">
            Ao publicar, uma nova versão das perguntas da anamnese será criada. 
            Esta ação não pode ser desfeita. Deseja continuar?
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="cancelPublish()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Cancelar
            </button>
            <button (click)="publishQuestions()"
                    [disabled]="publishLoading"
                    class="px-4 py-2 bg-westetics-blue hover:bg-westetics-blue-dark text-white rounded-md disabled:bg-gray-400">
                <span *ngIf="!publishLoading">Confirmar</span>
                <span *ngIf="publishLoading">Publicando...</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal de Confirmação de Exclusão -->
<div *ngIf="showDeleteConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faTrash" class="text-red-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg">Confirmar Exclusão</h3>
        </div>
        <p class="text-gray-600 mb-6">
            <span *ngIf="questionToDelete">
                Tem certeza que deseja excluir a pergunta "{{ questionToDelete.question.label }}"? 
                Esta ação não pode ser desfeita.
            </span>
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="cancelDeleteQuestion()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Cancelar
            </button>
            <button (click)="deleteQuestion()"
                    class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md">
                Excluir
            </button>
        </div>
    </div>
</div>

<!-- Modal de Confirmação de Fechamento -->
<div *ngIf="showCloseConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faExclamationTriangle" class="text-orange-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg">Alterações Não Salvas</h3>
        </div>
        <p class="text-gray-600 mb-6">
            Você possui alterações não salvas que serão perdidas se fechar o modal. 
            Deseja realmente sair sem salvar?
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="cancelClose()"
                    class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
                Continuar Editando
            </button>
            <button (click)="confirmClose()"
                    class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md">
                Sair Sem Salvar
            </button>
        </div>
    </div>
</div>

<!-- Modal de Erros de Validação -->
<div *ngIf="showValidationErrors" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        <div class="flex items-center mb-4">
            <fa-icon [icon]="faExclamationTriangle" class="text-red-500 mr-3" size="lg"></fa-icon>
            <h3 class="font-bold text-lg text-red-700">Campos Obrigatórios em Branco</h3>
        </div>
        <p class="text-gray-600 mb-4">
            Corrija os seguintes problemas antes de publicar:
        </p>
        <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <ul class="space-y-2">
                <li *ngFor="let error of validationErrorMessages" class="flex items-start gap-2">
                    <span class="text-red-500 mt-1">•</span>
                    <span class="text-red-700 text-sm">{{ error }}</span>
                </li>
            </ul>
        </div>
        <div class="flex justify-end">
            <button (click)="closeValidationErrors()"
                    class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md">
                Entendi, Vou Corrigir
            </button>
        </div>
    </div>
</div>
